// Reusable form section wrapper with title.
// Theme-aware: pulls border + text colors from admin tokens so light/dark toggles
// flip automatically.
import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { Text } from '@/components/common/text';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';

interface FormSectionProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  style?: ViewStyle;
}

export const FormSection: React.FC<FormSectionProps> = ({
  title,
  subtitle,
  children,
  style,
}) => {
  const styles = useStyles();

  return (
    <View style={[styles.section, style]}>
      <Text style={styles.title}>{title}</Text>
      {subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}
      {children}
    </View>
  );
};

const useStyles = () =>
  useThemedStyles(({ components, colors }) => {
    const admin = components.admin;
    return StyleSheet.create({
      section: {
        paddingVertical: 20,
        borderBottomWidth: 1,
        borderBottomColor: admin.dataTable.border,
      },
      title: {
        fontSize: 16,
        fontWeight: '600',
        color: admin.dataTable.text,
        marginBottom: 16,
      },
      subtitle: {
        fontSize: 13,
        color: colors.text.dim,
        marginBottom: 16,
      },
    });
  });
